import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {RemarkTypeService} from '../../../apiModule';

export const remarksResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, remarkTypeService: RemarkTypeService = inject(RemarkTypeService)) => {
  return remarkTypeService.apiRemarktypeGet({}, 'body', false, {transferCache: false});
};
